import { render, staticRenderFns } from "./moralAgreement.vue?vue&type=template&id=797d37ea&scoped=true&"
import script from "./moralAgreement.vue?vue&type=script&lang=js&"
export * from "./moralAgreement.vue?vue&type=script&lang=js&"
import style0 from "./moralAgreement.vue?vue&type=style&index=0&id=797d37ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d37ea",
  null
  
)

export default component.exports